import moment from "moment";
import { formatDuration, getEnvironmentInfo } from "./common";
import { render } from "@testing-library/react";

export const maxFileSizeInMB = 25;

export const AwsFileUploadGenericPath =
  "https://coolbiz-clone-s3.s3.us-east-1.amazonaws.com/public/"; //need changes for BottBuddy

// Validation messages for fields
export const validationMessages = {
  firstName: "First name is required",
  lastName: "Last name is required",
  emailRequired: "Email is required",
  emailInvalid: "Please enter a valid email",
  phoneRequired: "Phone number is required",
  phoneInvalid: "Please enter a valid phone number",
  faxInvalid: "Please enter a valid Fax",
  passwordRequired: "Password is required",
  passwordPatternErr:
    "Password must include uppercase, lowercase, number, and special character",
  emailPatternErr: "Not a valid email",
  passwordErr:
    "Password must 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one symbol",
  confirmPasswordRequired: "Confirm password is required",
  confirmPasswordMismatch: "Confirm password does not match with password",
  validUrl: "Enter valid URL",
  orgNameMin: "Organization name must be at least 3 characters long",
  promoCodePattern: "Promo code can only contain uppercase letters and numbers",
};

export const regex = {
  promoCodePattern: /^[A-Z0-9]+$/,
};

export const defaultValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  password: "",
  confirmPassword: "",
  businessUrl: "",
  organizationName: "",
  promoCode: "",
  isAgree: false,
};

export const defaultValuesLogin = {
  email: "",
  password: "",
};

export const validationMessagesForBotChatSettings = {
  chatbotDescription: "Chatbot description is required",
  toneRequired: "Tone is required",
  languageRequired: "Language is required",
  fontHeaderRequired: "Font Header is required",
  fontBodyRequired: "Font Body is required",
  responseLengthRequired: "Response Length is required",
  domainLinkRequired: "Domain link is required",
  domainLinkInvalid: "Must be a valid URL",
};

export const defaultValuesForBotChatSettings = {
  chatbotDescription: "",
  widgetToggle: false,
  tone: "",
  language: "",
  fontHeader: "",
  fontBody: "",
  responseLength: "",
  chatBubbleIcon: null,
  uploadChatbotAvatar: null,
  domainLink: "",
};

export const validationMessagesForCms = {
  title: "Title is reqired",
  subTitle: "Subtitle is reqired",
  description: "Description is reqired",
  cmsType: "CMS type is reqired",
};

export const defaultValuesForCms = {
  title: "",
  subTitle: "",
  description: "",
  cmsType: "",
  isLocked: false,
  isForAgency: true,
  files: null,
};
export const validationMessagesForUser = {
  name: "Full Name is reqired",
  firstName: "First Name is reqired",
  lastName: "Last Name is reqired",
  email: "Email is reqired",
  emailInValid: "Email is not valid",
  phoneNumber: "Phone Number is reqired",
};
export const defaultValuesForUsers = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  organizationName: "",
  businessUrl: "",
  plan: "",
  startDate: "",
  endDate: "",
};

export const defaultValuesForContactUs = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
  file: null,
  // agree: false,
};
export const defaultValuesForFeedback = {
  subject: "",
  message: "",
  files: null,
};
export const validationMessagesForCoupon = {
  expiresAtRequired: "Expiry date is required",
  couponDurationInMonthsvalid: "Coupon duration should be a valid nuymber",
  couponDurationInMonthsRequired:
    "Coupon duration in months required for recurring coupon",
  couponNameRequired: "Coupon name is required",
  maxRedemptionsRequired: "Max redemptions are required",
  maxRedemptionsPositive: "Must be greater than zero",
  maxRedemptionsInteger: "Must be an integer",
  couponDurationRequired: "Coupon duration is required",
  couponDurationInvalid: "Please select a valid duration",
  discountTypeRequired: "Discount type is required",
  discountTypeInvalid: "Invalid discount type",
  couponAmountRequired: "Coupon amount is required",
  couponAmountPositive: "Must be greater than zero",
  currencyRequired: "Currency is required",
  isEligibleRequired: "Eligibility is required",
  couponNameInvalid:
    "Counpon name can only contain uppercase letters and numbers",
};

export const defaultValuesForCoupon = {
  expiresAt: null,
  couponName: "",
  // max_redemptions: 1,
  couponDuration: "",
  discountType: "",
  couponAmount: "",
  currency: "inr",
  couponDurationInMonths: 0,
  years: 0,
  months: 0,
  weeks: 0,
  days: 0,
  // isEligibleForFirstTime: false,
};

export const validationMessagesForPlan = {
  planNameRequired: "Plan name is required",
  priceRequired: "Price is required",
  pricePositive: "Price must be greater than zero",
  currencyRequired: "Please choose a valid currency type.",
  noOfDayRequired: "No of days required",
  noOfDayMustBeNumber: "No of days must be greater that or eqaul to 1",
  planDescriptionRequired: "Plan description are required",
  planDescriptionMustBeOne: "Please choose at least one plan description",
  planSubscriptionType: "Please choose a subscription type",
  messageCountRequired: "Message count is required",
  noOfBotsRequired: "No of bots is required",
};

export const defaultValuesForPlan = {
  planName: "",
  price: "",
  currency: "inr",
  module: [],
  isFreePlan: true,
  noOfDay: "",
  allowPromotionCode: false,
  autoCollectTax: true,
  subscriptionType: "",
  userType: false,
};

export const LABEL = {
  TOAST_TYPE: {
    SUCCESS: "success",
    ERROR: "error",
    INFO: "info",
    WARN: "warn",
  },
  SIGNUP: {
    ERROR_MESSAGE: {
      FAILED: "Registration Failed",
    },
  },
  USER_MANAGEMENT: {
    TITLE: {
      NAME: "Full Name",
      EMAIL: "Email",
      ORGANIZATION: "Organization Name",
      TRILE: "Trial User",
    },
    KEY: {
      FIRSTNAME: "firstName",
      LASTNAME: "lastName",
      NAME: "fullName",
      EMAIL: "email",
      ORGANIZATION: "organizationName",
      TRILE: "isTrial",
    },
  },
  TABLE_COLUMN: {
    POSSITION: {
      LEFT: "left",
      RIGHT: "right",
      CENTER: "center",
      WORD_BREAK: "break-word",
    },
    ACTION: {
      EDIT: {
        LABEL: "Edit",
        ICON: "/images/icons/edit-icon.svg",
      },
      DELETE: {
        LABEL: "Delete",
        ICON: "/images/icons/delete-icon.svg",
      },
      VIEW: {
        LABEL: "View Invoice",
        ICON: "/images/icons/eye-icon-green.png",
      },
      VIEW_White: {
        LABEL: "View",
        ICON: "/images/icons/eye-icon-white.svg",
      },
      DOWNLOAD: {
        LABEL: "Download Invoice",
        ICON: "/images/icons/fax-icon.svg",
      },
    },
  },
  BOT_CHAT_SETTINGS: {
    TITLE: "Bot Chat Settings",
    SAVE_AND_CONTINUE: "Save and continue",
    CHATBOT_DESCRIPTION: "Chatbot Description",
    DOMAIN_LINK: "Domain Link",
    UPLOAD_WIDGET: "Upload widget",
    CHAT_BUBBLE_ICON: "Chat Bubble Icon",
    UPLOAD_AVATAR: "Upload Chatbot Avatar",
  },
  COUPON_SETTINGS: {
    TITLE: "Create Promo Code",
    COUPON_NAME: "Promo Code",
    MAX_REDEMPTIONS: "Max Redemptions",
    COUPON_DURATION: "Promocode Duration",
    DISCOUNT_TYPE: "Discount Type",
    COUPON_AMOUNT: "Promocode Amount",
    CURRENCY: "Currency",
    ELIGIBLE_FOR_FIRST_TIME: "Eligible for First-Time Users",
    SAVE_AND_CONTINUE: "Save and Continue",
    EXPIRES_AT: "Expires In",
    DURATION_IN_MONTHS: "Duration (In Months)",

    TABLE_COLUMN: {
      TITLE: {
        COUPON_NAME: "Promo Code",
        COUPON_CODE: "Coupon Code",
        COUPON_AMOUNT: "Amount",
        COUPON_DURATION: "Duration",
        COUPON_EXPIRE: "Expiry Date",
        COUPON_EXPIRE_IN: "Expires In",
        COUPON_CREATED: "Created On",
        COUPON_STATUS: "Status",
      },
      KEY: {
        COUPON_NAME: "couponName",
        COUPON_CODE: "couponCode",
        COUPON_AMOUNT: "couponAmount",
        COUPON_DURATION: "couponDuration",
        COUPON_EXPIRE: "expiresAt",
        COUPON_STATUS: "status",
        COUPON_EXPIRE_IN: "Expires In",
        COUPON_CREATED: "createdAt",
      },
    },
  },

  PLAN_MANAGEMENT: {
    TITLE: "Create Plan",
    TITLE_EDIT: "View Plan",
    TITLE_VIEW: "Plan Details",
    PLAN_NAME: "Plan Name",
    PRICE: "Price",
    CURRENCY: "Currency",
    BOT_COUNT: "No of bots could be created",
    MESSAGE_COUNT: "No of messages could be sent",
    FOR_TRILE: "Allow Trial",
    NO_OF_DAYS: "Trial Days",
    ALLOW_PORMOTION_CODE: "Allow Promotion code",
    ALLOW_TAX: "Allow To Collect TAX",
    FOR_AGENCY: "Agency Plan",
    ALLOW_SUBSCRIPTION: "Allow For Subscription Type",
    PLAN_DESCRIPTION: "Select Plan Description",
    SAVE_AND_CONTINUE: "Save and Continue",
    PLAN_MANAGEMENT: "Plan Management",
    TABLE_COLUMN: {
      TITLE: {
        PLAN_NAME: "Plan Name",
        PLAN_TRILE: "Available With Trial",
        TRAIL_DAYS: "Free Trial Days",
        PLAN_CURRENCY: "Currency",
        PLAN_PRICE: "Plan Price",
        PLAN_EXPIRE: "Expires At",
        ALLOW_PROMO: "Allow Promotioncode",
        PLAN_STATUS: "Status",
        Is_AGENCY_PLAN: "Is Agency Plan?",
      },
      KEY: {
        PLAN_NAME: "planName",
        PLAN_TRILE: "isFreePlan",
        TRAIL_DAYS: "noOfDay",
        PLAN_CURRENCY: "currency",
        PLAN_PRICE: "price",
        PLAN_EXPIRE: "expiresAt",
        ALLOW_PROMO: "allowPromotionCode",
        PLAN_STATUS: "status",
        Is_AGENCY_PLAN: "userType",
      },
    },
  },
  SUBSCRIPTION_MANAGEMENT: {
    TITLE: "Create Subscription",
    TITLE_EDIT: "Edit Plan",
    SUBSCRIPTION_NAME: "Plan Name",
    PRICE: "Price",
    CURRENCY: "Currency",
    FOR_TRILE: "Allow Trile",
    NO_OF_DAYS: "Trile Days",
    ALLOW_PORMOTION_CODE: "Allow Promotion code",
    ALLOW_TAX: "Allow To Collect TAX",
    ALLOW_SUBSCRIPTION: "Allow For Subscription Type",
    SUBSCRIPTION_DESCRIPTION: "Select Plan Description",
    SAVE_AND_CONTINUE: "Save and Continue",
    HEADLINE: {
      subscriber: "Customer Subscription Details",
      parent_agency: "Agency Subscription Details",
      child: "Child Subscription Details",
    },
    TABLE_COLUMN: {
      TITLE: {
        PLAN_NAME: "Plan Name",
        PLAN_TRILE: "Available With Trial",
        TRAIL_DAYS: "Free Trial Days",
        PLAN_CURRENCY: "Currency",
        PLAN_PRICE: "Plan Price",
        PLAN_EXPIRE: "Expires At",
        ALLOW_PROMO: "Allow Promotioncode",
        PLAN_STATUS: "Status",
      },
      KEY: {
        PLAN_NAME: "planName",
        PLAN_TRILE: "isFreePlan",
        TRAIL_DAYS: "noOfDay",
        PLAN_CURRENCY: "currency",
        PLAN_PRICE: "price",
        PLAN_EXPIRE: "expiresAt",
        ALLOW_PROMO: "allowPromotionCode",
        PLAN_STATUS: "status",
      },
    },
  },
  USER: {
    USER_ID_NOT_FOUND: "Please reload the page or Login Again!",
    EDIT_HEADER: "Edit Customer Details",
    HEADER: "Add New Customer",
    NAME: "Full Name",
    FIRSTNAME: "First Name",
    LASTNAME: "Last Name",
    EMAIL: "Email",
    PHONE: "Phone Number",
    STATUS: "Status",
  },
  CMS: {
    HEADER: "Add New Content",
    EDIT_HEADER: "Edit Content",
    SAVE_AND_CONTINUE: "Save and continue",
    TITLE: "Title",
    SUBTITLE: "Subtitle",
    DESCRIPTION: "Description",
    UPLOAD_WIDGET: "Upload widget",
    CHAT_BUBBLE_ICON: "Upload Icon",
    UPLOAD_VIDEO: "Upload Video",
    UPLOAD_AVATAR: "Upload Chatbot Avatar",
  },
  REVENEU: {
    HEADLINE: "Revenue Report",
    TOTAL_TRANSACTION: "Total Amount: ",
    TOTAL_TAX: "Tax Amount: ",
  },
  SOCIAL_LINK: {
    HEADING: "Social Link Management",
  },
  EMAIL_MANAGEMENT: {
    HEADING: "Email Sender Configuration",
  },
};

const UMK = LABEL.USER_MANAGEMENT.KEY;
const UMT = LABEL.USER_MANAGEMENT.TITLE;
export const TCP = LABEL.TABLE_COLUMN.POSSITION;
export const TCA = LABEL.TABLE_COLUMN.ACTION;

const CMTCK = LABEL.COUPON_SETTINGS.TABLE_COLUMN.KEY;
const CMTCT = LABEL.COUPON_SETTINGS.TABLE_COLUMN.TITLE;

export const PMTCK = LABEL.PLAN_MANAGEMENT.TABLE_COLUMN.KEY;
export const PMTCT = LABEL.PLAN_MANAGEMENT.TABLE_COLUMN.TITLE;

export const TABLE_CONSTANT = {
  usersManagementcolumns: [
    { key: UMK.NAME, title: UMT.NAME, align: TCP.LEFT },
    { key: UMK.EMAIL, title: UMT.EMAIL, align: TCP.LEFT },
    { key: "phoneNumber", title: "Phone", align: TCP.LEFT },
    {
      key: "planName",
      title: "Plan",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? value : "NA"}
          </span>
        );
      },
    },

    {
      key: "startDate",
      title: "Start Date",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? moment(new Date(value)).format("DD MMMM YYYY") : "NA"}
          </span>
        );
      },
    },
    {
      key: "endDate",
      title: "End Date",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? moment(new Date(value)).format("DD MMMM YYYY") : "NA"}
          </span>
        );
      },
    },

    {
      key: "promoCode",
      title: "Promocode",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? value : "NA"}
          </span>
        );
      },
    },
    {
      key: "status",
      title: "Status",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <div className={value === 1 ? "statusActive" : "statusInactive"}>
            {value === 1 ? "Active" : "Inactive"}
          </div>
        );
      },
    },
    {
      key: "isDeleted",
      title: "Is Deleted?",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? "Yes" : "No"}
          </span>
        );
      },
    },
    // {
    //   key: UMK.TRILE,
    //   title: UMT.TRILE,
    //   align: TCP.CENTER,
    //   wordBreak: TCP.WORD_BREAK,
    //   render: (value, item) => {
    //     return <span style={{ textTransform: "uppercase" }}>{value ? 'Free Trial' : 'Trial Expired'}</span>
    //   }
    // },
  ],

  usersManagementactions: [
    {
      label: TCA.EDIT.LABEL,
      icon: TCA.EDIT.ICON,
      onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    },
    // {
    //   label: TCA.DELETE.LABEL,
    //   icon: TCA.DELETE.ICON,
    //   onClick: (item) => alert(`Delete ${item[UMK.NAME]}`),
    // },
  ],
  agencyManagementColumns: [
    { key: UMK.NAME, title: UMT.NAME, align: TCP.LEFT },
    {
      key: "organizationName",
      title: "Organization Name",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value ? value : "N/A"}</span>;
      },
    },
    { key: UMK.EMAIL, title: UMT.EMAIL, align: TCP.CENTER },
    { key: "phoneNumber", title: "Phone", align: TCP.CENTER },
    {
      key: "planName",
      title: "Plan",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? value : "NA"}
          </span>
        );
      },
    },
    {
      key: "promoCode",
      title: "Promocode",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? value : "NA"}
          </span>
        );
      },
    },
    {
      key: "status",
      title: "Status",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <div className={value === 1 ? "statusActive" : "statusInactive"}>
            {value === 1 ? "Active" : "Inactive"}
          </div>
        );
      },
    },
    {
      key: "isDeleted",
      title: "Is Deleted?",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? "Yes" : "No"}
          </span>
        );
      },
    },
    // {
    //   key: UMK.TRILE,
    //   title: UMT.TRILE,
    //   align: TCP.CENTER,
    //   wordBreak: TCP.WORD_BREAK,
    //   render: (value, item) => {
    //     return <span style={{ textTransform: "uppercase" }}>{value ? 'Free Trial' : 'Trial Expired'}</span>
    //   }
    // },
  ],
  agencyManagementActions: [
    {
      label: TCA.EDIT.LABEL,
      icon: TCA.EDIT.ICON,
      onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    },
  ],
  agencyUserColumns: [
    { key: "agencyName", title: "Agency Name", align: TCP.LEFT },
    { key: "totalSubscribers", title: "Total Subscribers", align: TCP.CENTER },
    { key: "totalBots", title: "Total Chatbot", align: TCP.CENTER },
  ],
};
export const AFFILIATE_TABLE_CONSTANT = {
  columns: [
    { key: "fullName", title: "Name", align: TCP.LEFT },
    { key: "email", title: "Email", align: TCP.LEFT },
    { key: "phoneNumber", title: "Phone Number", align: TCP.LEFT },
    {
      key: "createdAt",
      title: "Joining Date",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
    {
      key: "affiliateDetails",
      title: "Invitation Link",
      align: TCP.CENTER,
      render: (value, item) => {
        const invitationLink = `${siteURLs[environment()]}/pricing?referral=${
          value[0]?.refererCode
        }`;
        // const copyToClipboard = () => {
        //   navigator.clipboard.writeText(invitationLink).then(() => {
        //   }).catch(error => {
        //   });
        // };
        return (
          <div className="invitationLink" style={{}}>
            {invitationLink}
            {/* <button className="invitationLinkCopy" onClick={copyToClipboard} style={{ marginLeft: '10px' }}><img src="/images/icons/copy-icon" alt="copy-icon" /></button> */}
          </div>
        );
      },
    },
    {
      key: "isDeleted",
      title: "Is Deleted?",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? "Yes" : "No"}
          </span>
        );
      },
    },
    {
      key: "status",
      title: "Status",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <div className={value === 1 ? "statusActive" : "statusInactive"}>
            {value === 1 ? "Active" : "Inactive"}
          </div>
        );
      },
    },
  ],
  commissionColumn: [
    { key: "fullName", title: "Name", align: TCP.LEFT },
    { key: "email", title: "Email", align: TCP.LEFT },
    { key: "totalAmount", title: "Total Amount", align: TCP.CENTER },
    { key: "holdAmount", title: "Holding Amount", align: TCP.CENTER },
    { key: "completeAmount", title: "Settled Amount", align: TCP.CENTER },
  ],
  commissionActions: [
    {
      label: "View Plan",
      icon: "/images/icons/eye-icon-white.svg",
      onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    },
  ],
  actions: [
    {
      label: "Edit",
      icon: TCA.EDIT.ICON,
      onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    },
  ],
};
export const EMPLOYEE_TABLE_CONSTANT = {
  columns: [
    { key: "fullName", title: "Name", align: TCP.LEFT },
    { key: "email", title: "Email", align: TCP.LEFT },
    { key: "phoneNumber", title: "Phone Number", align: TCP.LEFT },
    {
      key: "Role",
      title: "Designation",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value?.roleName || "N/A"}
          </span>
        );
      },
    },
    {
      key: "createdAt",
      title: "Joining Date",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
    // {
    //   key: "isDeleted",
    //   title: "Is Deleted?",
    //   align: TCP.CENTER,
    //   render: (value) => {
    //     return (
    //       <span style={{ textTransform: "uppercase" }}>
    //         {value ? "Yes" : "No"}
    //       </span>
    //     );
    //   },
    // },
    {
      key: "status",
      title: "Status",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <div className={value === 1 ? "statusActive" : "statusInactive"}>
            {value === 1 ? "Active" : "Inactive"}
          </div>
        );
      },
    },
  ],
  actions: [
    {
      label: "Edit",
      icon: TCA.EDIT.ICON,
      onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    },
    {
      label: "Delete",
      icon: TCA.DELETE.ICON,
      onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    },
  ],
};

const fontHeaderOptions = [
  { label: "Poppins Bold", value: "Poppins-Bold" },
  { label: "Montserrat Extra Bold", value: "Montserrat-ExtraBold" },
  { label: "Open Sans Extra Bold", value: "OpenSans-ExtraBold" },
  { label: "Roboto Bold", value: "Roboto-Bold" },
  { label: "Bebas Neue", value: "BebasNeue" },
  { label: "Playfair Display Bold", value: "PlayfairDisplay-Bold" },
];

const fontBodyOptions = [
  { label: "Poppins Regular", value: "Poppins-Regular" },
  { label: "Open Sans Regular", value: "OpenSans-Regular" },
  { label: "Lato Regular", value: "Lato-Regular" },
  { label: "Roboto Regular", value: "Roboto-Regular" },
  { label: "Georgia Regular", value: "Georgia-Regular" },
  { label: "Merriweather Regular", value: "Merriweather-Regular" },
];

const responseLengthOptions = [
  { label: "Small", value: "small" },
  { label: "Medium", value: "medium" },
  { label: "Large", value: "large" },
];

const languageOptions = [
  { label: "English (US)", value: "en-us" },
  { label: "English (UK)", value: "en-uk" },
  { label: "Spanish (Español)", value: "es" },
  { label: "French (Français)", value: "fr" },
  { label: "German (Deutsch)", value: "de" },
  { label: "Hindi (हिंदी)", value: "hi" },
  { label: "Mandarin Chinese (中文)", value: "zh" },
  { label: "Japanese (日本語)", value: "ja" },
  { label: "Arabic (العربية)", value: "ar" },
  { label: "Swahili (Kiswahili)", value: "sw" },
];

const toneOptions = [
  { label: "Informative", value: "informative" },
  { label: "Professional", value: "professional" },
  { label: "Humorous", value: "humorous" },
  { label: "Friendly", value: "friendly" },
  { label: "Persuasive", value: "persuasive" },
  { label: "Casual", value: "casual" },
  { label: "Empathetic", value: "empathetic" },
  { label: "Inspirational", value: "inspirational" },
];

export const dropdownConfigs = [
  {
    name: "tone",
    label: "Tone",
    options: toneOptions,
  },
  {
    name: "language",
    label: "Language",
    options: languageOptions,
  },
  {
    name: "fontHeader",
    label: "Font Header",
    options: fontHeaderOptions,
  },
  {
    name: "fontBody",
    label: "Font Body",
    options: fontBodyOptions,
  },
  {
    name: "responseLength",
    label: "Response Length",
    options: responseLengthOptions,
  },
];

export const currencyOptions = [
  { value: "usd", label: "$ - USD" }, // US Dollar
  // { value: "eur", label: "€ - EUR" }, // Euro
  { value: "inr", label: "₹ - INR" }, // Indian Rupee
  // { value: "gbp", label: "£ - GBP" }, // British Pound Sterling
  // { value: "jpy", label: "¥ - JPY" }, // Japanese Yen
  // { value: "aud", label: "A$ - AUD" }, // Australian Dollar
  // { value: "cad", label: "C$ - CAD" }, // Canadian Dollar
  // { value: "chf", label: "CHF - CHF" }, // Swiss Franc
  // { value: "cny", label: "¥ - CNY" }, // Chinese Yuan
  // { value: "rub", label: "₽ - RUB" }, // Russian Ruble
  // { value: "brl", label: "R$ - BRL" }, // Brazilian Real
  // { value: "zar", label: "R - ZAR" }, // South African Rand
  // { value: "mxn", label: "$ - MXN" }, // Mexican Peso
  // { value: "nzd", label: "NZ$ - NZD" }, // New Zealand Dollar
  // { value: "krw", label: "₩ - KRW" }, // South Korean Won
  // { value: "sgd", label: "S$ - SGD" }, // Singapore Dollar
  // { value: "hkd", label: "HK$ - HKD" }, // Hong Kong Dollar
  // { value: "sek", label: "kr - SEK" }, // Swedish Krona
  // { value: "nok", label: "kr - NOK" }, // Norwegian Krone
  // { value: "dkk", label: "kr - DKK" }, // Danish Krone
  // { value: "pln", label: "zł - PLN" }, // Polish Zloty
  // { value: "try", label: "₺ - TRY" }, // Turkish Lira
  // { value: "thb", label: "฿ - THB" }, // Thai Baht
  // { value: "idr", label: "Rp - IDR" }, // Indonesian Rupiah
];
export const currencyWithSymbolObj = {
  usd: "$", // US Dollar
  eur: "€", // Euro
  inr: "₹", // Indian Rupee
  gbp: "£", // British Pound Sterling
  jpy: "¥", // Japanese Yen
  aud: "A$", // Australian Dollar
  cad: "C$", // Canadian Dollar
  chf: "CHF", // Swiss Franc
  cny: "¥", // Chinese Yuan
  rub: "₽", // Russian Ruble
  brl: "R$", // Brazilian Real
  zar: "R", // South African Rand
  mxn: "$", // Mexican Peso
  nzd: "NZ$", // New Zealand Dollar
  krw: "₩", // South Korean Won
  sgd: "S$", // Singapore Dollar
  hkd: "HK$", // Hong Kong Dollar
  sek: "kr", // Swedish Krona
  nok: "kr", // Norwegian Krone
  dkk: "kr", // Danish Krone
  pln: "zł", // Polish Zloty
  try: "₺", // Turkish Lira
  thb: "฿", // Thai Baht
  idr: "Rp", // Indonesian Rupiah
};
export const subscriptionTypeOptions = [
  { value: 1, label: "Monthly" },
  { value: 2, label: "Yearly" },
  ...(process.env.NODE_ENV != "production"
    ? [{ value: 3, label: "Daily" }]
    : []),
];

export const discountTypeOptions = [
  { value: 1, label: "Percent" },
  { value: 2, label: "Fixed" },
];

export const couponDurationOptions = [
  { value: "once", label: "One Time" },
  // { value: "repeating", label: "Recurring" },
  { value: "forever", label: "Lifetime" },
];

export const getCurrencySymbol = (currency = "") => {
  let lsCurrency = !!currency
    ? currency?.toLocaleLowerCase()
    : localStorage.getItem("currency")?.toLocaleLowerCase();
  if (
    lsCurrency === "inr" ||
    lsCurrency === "aud" ||
    lsCurrency === "gbp" ||
    lsCurrency === "jpy"
  )
    return currencyWithSymbolObj[lsCurrency];
  else return "$";
};

export const getPriceAfterExchange = (price, currency = "", rate) => {
  let lsCurrency = !!currency
    ? currency?.toLocaleLowerCase()
    : localStorage.getItem("currency")?.toLocaleLowerCase();
  // console.log("price, currency, rate", price, lsCurrency, rate);
  if (lsCurrency === "aud" || lsCurrency === "gbp" || lsCurrency === "jpy")
    return (price * rate[lsCurrency]).toFixed(2);
  else return price;
};

// One Time, Recurring, Lifetime
// export const couponDurationOptions = [
//   { value: "one_time", label: "One Time" },
//   { value: "recurring", label: "Recurring" },
//   { value: "lifetime", label: "Lifetime" },
// ];

export const couponDropdownConfigs = [
  {
    name: "discountType",
    label: "Discount Type",
    options: discountTypeOptions,
  },
  {
    name: "couponDuration",
    label: "Coupon Duration",
    options: couponDurationOptions,
  },
  {
    name: "couponDuration",
    label: "Coupon Duration",
    options: currencyOptions,
  },
];

export const COUPON_TABLE_CONSTANT = {
  usersManagementcolumns: [
    { key: CMTCK.COUPON_NAME, title: CMTCT.COUPON_NAME, align: TCP.LEFT },
    // { key: CMTCK.COUPON_CODE, title: CMTCT.COUPON_CODE, align: TCP.CENTER },
    { key: CMTCK.COUPON_AMOUNT, title: CMTCT.COUPON_AMOUNT, align: TCP.CENTER },
    {
      key: CMTCK.COUPON_DURATION,
      title: CMTCT.COUPON_DURATION,
      align: TCP.CENTER,
    },
    {
      key: CMTCK.COUPON_CREATED,
      title: CMTCT.COUPON_CREATED,
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? `${moment(value).format("DD MMMM YYYY")}` : "NA"}
          </span>
        );
      },
    },
    {
      key: CMTCK.COUPON_EXPIRE_IN,
      title: CMTCT.COUPON_EXPIRE_IN,
      align: TCP.CENTER,
      render: (value, item) => {
        const { years, months, days, weeks } = item;
        return (
          <span style={{ textTransform: "uppercase" }}>
            {formatDuration({ years, months, weeks, days })}
          </span>
        );
      },
    },
    {
      key: CMTCK.COUPON_EXPIRE,
      title: CMTCT.COUPON_EXPIRE,
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? `${moment(value).format("DD MMMM YYYY")}` : "NA"}
          </span>
        );
      },
    },
    {
      key: CMTCK.COUPON_STATUS,
      title: CMTCT.COUPON_STATUS,
      align: TCP.LEFT,
      wordBreak: TCP.WORD_BREAK,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value === 1 ? "Active" : "Inactive"}
          </span>
        );
      },
    },
  ],

  usersManagementactions: [
    // {
    //   label: TCA.EDIT.LABEL,
    //   icon: TCA.EDIT.ICON,
    //   onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    // },
    {
      label: TCA.DELETE.LABEL,
      icon: TCA.DELETE.ICON,
      onClick: (item) => alert(`Delete ${item[UMK.NAME]}`),
    },
  ],
};

export const PLAN_TABLE_CONSTANT = {
  usersManagementcolumns: [
    { key: PMTCK.PLAN_NAME, title: PMTCT.PLAN_NAME, align: TCP.LEFT },
    {
      key: PMTCK.PLAN_TRILE,
      title: PMTCT.PLAN_TRILE,
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value === 1 ? "YES" : "NO"}
          </span>
        );
      },
    },
    {
      key: PMTCK.TRAIL_DAYS,
      title: PMTCT.TRAIL_DAYS,
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value ?? "NA"}</span>;
      },
    },
    {
      key: PMTCK.PLAN_CURRENCY,
      title: PMTCT.PLAN_CURRENCY,
      align: TCP.CENTER,
      render: (value, item) => {
        return <span style={{ textTransform: "uppercase" }}>{value}</span>;
      },
    },
    {
      key: PMTCK.PLAN_PRICE,
      title: PMTCT.PLAN_PRICE,
      align: TCP.CENTER,
    },
    {
      key: PMTCK.ALLOW_PROMO,
      title: PMTCT.ALLOW_PROMO,
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value === 1 ? "YES" : "NO"}
          </span>
        );
      },
    },
    {
      key: PMTCK.PLAN_STATUS,
      title: PMTCT.PLAN_STATUS,
      align: TCP.LEFT,
      wordBreak: TCP.WORD_BREAK,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value === 1 ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      key: PMTCK.Is_AGENCY_PLAN,
      title: PMTCT.Is_AGENCY_PLAN,
      align: TCP.CENTER,
      wordBreak: TCP.WORD_BREAK,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value === 3 ? "Yes" : "No"}
          </span>
        );
      },
    },
  ],
};

export const MANAGE_SUBSCRIBERS_TABLE_CONSTANT = {
  usersManagementcolumns: [
    {
      key: "email",
      title: "Email",
      align: TCP.LEFT,
    },
    {
      key: "subscriptionStartDate",
      title: "Payment Status",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span>{item?.activeSubscription?.paymentStatusMessage ?? "NA"}</span>
        );
      },
    },
    {
      key: "subscriptionStartDate",
      title: "Payment Type",
      align: TCP.CENTER,
      render: (value, item) => {
        return <span>{item?.activeSubscription?.paymentType ?? "NA"}</span>;
      },
    },
    {
      key: "activeSubscription.subscriptionStartDate",
      title: "Subscription Start",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {item?.activeSubscription?.subscriptionStartDate
              ? `${moment(
                  item?.activeSubscription?.subscriptionStartDate,
                ).format("DD MMMM YYYY")}`
              : "NA"}
          </span>
        );
      },
    },
    {
      key: "activeSubscription.subscriptionEndDate",
      title: "Subscription End",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {item?.activeSubscription?.subscriptionEndDate
              ? `${moment(item?.activeSubscription?.subscriptionEndDate).format(
                  "DD MMMM YYYY",
                )}`
              : "NA"}
          </span>
        );
      },
    },
  ],
};
export const MANAGE_REVENEU_TABLE_CONSTANT = {
  usersManagementcolumns: [
    {
      key: "fullName",
      title: "User Name",
      align: TCP.LEFT,
    },
    {
      key: "email",
      title: "Email",
      align: TCP.LEFT,
    },
    {
      key: "taxAmount",
      title: "Tax Amount",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <span>
            {value === null || value === undefined ? "NA" : (+value).toFixed(2)}
          </span>
        );
      },
    },
    {
      key: "subTotal",
      title: "Sub Total",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <span>
            {value === null || value === undefined ? "NA" : (+value).toFixed(2)}
          </span>
        );
      },
    },
    {
      key: "totalAmountReceived",
      title: "Total Amount",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <span>
            {value === null || value === undefined ? "NA" : (+value).toFixed(2)}
          </span>
        );
      },
    },
  ],
  usersManagementactions: [
    {
      label: "View",
      icon: "/images/icons/eye-icon-white.svg",
      onClick: () => {},
    },
  ],
};
export const DESIGNATION_TABLE = {
  columns: [
    {
      key: "roleName",
      title: "Designations",
      align: TCP.LEFT,
    },
    {
      key: "createdAt",
      title: "Create",

      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
    {
      key: "roleStatus",
      title: "Status",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <div className={value === 1 ? "statusActive" : "statusInactive"}>
            {value === 1 ? "Active" : "Inactive"}
          </div>
        );
      },
    },
  ],
};
export const MODEL_TABLE_CONSTANT = {
  usersManagementcolumns: [
    { key: "baseModelName", title: "Model Name", align: TCP.LEFT },
    {
      key: "createdAt",
      title: "Created Date",
      align: TCP.LEFT,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
    {
      key: PMTCK.PLAN_STATUS,
      title: PMTCT.PLAN_STATUS,
      align: TCP.LEFT,
      wordBreak: TCP.WORD_BREAK,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value === 1 ? "Active" : "Inactive"}
          </span>
        );
      },
    },
  ],
};
export const CHATBOT_CONTACTS_TABLE_CONSTANT = {
  usersManagementcolumns: [
    {
      key: "first_name",
      title: "First Name",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    {
      key: "last_name",
      title: "Last Name",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    {
      key: "email",
      title: "Email",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    {
      key: "phone",
      title: "Phone",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    // {
    //   key: "chat_type",
    //   title: "Chat Type",
    //   align: TCP.CENTER,
    //   render: (value) => {
    //     return <span>{value || "Bot"}</span>;
    //   },
    // },
    {
      key: "created_at",
      title: "Created Date",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
    {
      key: "updated_at",
      title: "Updated Date",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
  ],

  usersManagementRegColumns: [
    {
      key: "first_name",
      title: "First Name",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    {
      key: "last_name",
      title: "Last Name",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    {
      key: "email",
      title: "Email",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    {
      key: "phone_number",
      title: "Phone",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "N/A"}</span>;
      },
    },
    // {
    //   key: "chat_type",
    //   title: "Chat Type",
    //   align: TCP.CENTER,
    //   render: (value) => {
    //     return <span>{value || "Bot"}</span>;
    //   },
    // },
    {
      key: "created_at",
      title: "Created Date",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
    {
      key: "updated_at",
      title: "Updated Date",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {moment(new Date(value)).format("DD MMMM YYYY")}
          </span>
        );
      },
    },
  ],
};
export const CHATBOT_METADATA_TABLE_CONSTANT = {
  usersManagementcolumnsOwn: [
    {
      key: "bot",
      title: "Chatbot",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? value?.bot_name || "N/A" : "N/A"}
          </span>
        );
      },
    },
    {
      key: "deviceInfo",
      title: "Device Info(IP Address)",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value != "undefined" ? value : "N/A"}
          </span>
        );
      },
    },
    {
      key: "systemInfo",
      title: "Browser Name",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value != "undefined" ? JSON.parse(value)?.browserName : "N/A"}
          </span>
        );
      },
    },
    { key: "email", title: "Email", align: TCP.CENTER },
    {
      key: "bot_tags",
      title: "Tags",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value.length ? value.join(",") : "N/A"}
          </span>
        );
      },
    },
    {
      key: CMTCK.COUPON_CREATED,
      title: "Timestamp",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? `${moment(value).format("DD MMMM YYYY")}` : "NA"}
          </span>
        );
      },
    },
  ],
  usersManagementcolumnsOwn: [
    {
      key: "bot",
      title: "Chatbot",
      align: TCP.LEFT,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? value?.bot_name || "N/A" : "N/A"}
          </span>
        );
      },
    },
    {
      key: "deviceInfo",
      title: "Device Info(IP Address)",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value != "undefined" ? value : "N/A"}
          </span>
        );
      },
    },
    {
      key: "systemInfo",
      title: "Browser Name",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value != "undefined" ? JSON.parse(value)?.browserName : "N/A"}
          </span>
        );
      },
    },
    { key: "email", title: "Email", align: TCP.CENTER },
    {
      key: "complianceCheck",
      title: "Compliance Check",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? value : "N/A"}
          </span>
        );
      },
    },
    {
      key: "bot_tags",
      title: "Tags",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? (value.length ? value.join(",") : "N/A") : "N/A"}
          </span>
        );
      },
    },
    {
      key: CMTCK.COUPON_CREATED,
      title: "Timestamp",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {value ? `${moment(value).format("DD MMMM YYYY")}` : "NA"}
          </span>
        );
      },
    },
  ],
  usersManagementactions: [
    {
      label: "View Plan",
      icon: TCA.VIEW_White.ICON,
      onClick: (item) => alert(`Delete ${item[UMK.NAME]}`),
    },
  ],
};
export const replaceActionCallback = (
  actions,
  label,
  newCallback,
  isShow = true,
) => {
  if (!isShow) return null;
  return actions.map((action) =>
    action.label === label ? { ...action, onClick: newCallback } : action,
  );
};

// export const mapToLabelAndValues = (list = [], value = 'id', label = 'description') => {
//   return list.map((plan) => ({
//     value: plan[value],
//     label: plan[label],
//   }));
// };

export const mapToLabelAndValues = (
  list = [],
  valueKey = "id",
  labelKey = "description",
) => {
  return list.map((item) => ({
    value: item[valueKey],
    label: labelKey.includes(".")
      ? labelKey.split(".").reduce((acc, key) => acc?.[key], item)
      : item[labelKey],
  }));
};

export function transformBooleanToNumber(payload) {
  const transformedPayload = Object.keys(payload).reduce((acc, key) => {
    const value = payload[key];

    if (typeof value === "boolean") {
      acc[key] = value ? 1 : 0;
    } else {
      acc[key] = value;
    }

    return acc;
  }, {});

  return transformedPayload;
}

export const user_type = {
  1: "super_admin",
  2: "subscriber",
  3: "parent_agency",
  4: "child_client",
  5: "affiliate",
  6: "employee",
};

export const paginationObj = {
  item_per_page: 10,
};

export const cmsTypeOptions = [
  { label: "Chatbot Features", value: 4 },
  { label: "Chatbot Integration Guides", value: 1 },
  { label: "FAQs", value: 2 },
  { label: "Onboarding Tutorials", value: 3 },
  { label: "Terms of Service", value: 7 },
  { label: "Privacy Policy", value: 6 },
  { label: "Agency Policy", value: 12 },
  // { label: "Affiliate Policy", value: 13 },
  { label: "Refund Policy", value: 5 },
  { label: "Business Associate Agreement (BAA)", value: 15 },
  { label: "Data Processing Agreement (DPA)", value: 16 },
  { value: 17, label: "Home Demo Video" },
  // { label: "Affiliate Title", value: 8 },
  // { label: "Affiliate Header", value: 9 },
  // { label: "Affiliate Benifits", value: 10 },
  // { label: "Affiliate Footer", value: 11 },
];

export const cmsTypeObj = {
  1: "Chatbot Integration Guides",
  2: "FAQs",
  3: "Onboarding Tutorials",
  4: "Chatbot Features",
  5: "Refund Policy",
  6: "Privacy Policy",
  7: "Terms of Service",
  // 8:"Affiliate Title",
  // 9:"Affiliate Header",
  // 10:"Affiliate Benifits",
  // 11:"Affiliate Footer",
  12: "Agency Policy",
  // 13: "Affiliate Policy",
  15: "Business Associate Agreement (BAA)",
  16: "Data Processing Agreement (DPA)",
};

export const siteURLs = {
  prod: "https://bottbuddy.com",
  dev: "https://test-dev.bottbuddy.com",
  local: "http://localhost:3000",
};

export function environment() {
  const baseUrl = process.env.REACT_APP_FRONTEND_BASE_URL;
  if (baseUrl.includes("bottbuddy.com") && !baseUrl.includes("dev")) {
    return "prod";
  }
  if (baseUrl.includes("dev.bottbuddy.com")) {
    return "dev";
  }
  return "local";
}

function truncateString(str, maxLength = 50) {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
}

export const CMS_TABLE_CONSTANT = {
  usersManagementcolumns: [
    {
      key: "title",
      title: "Title",
      align: TCP.LEFT,
      render: (value) => {
        return <span>{truncateString(value, 25) || "NA"}</span>;
      },
    },
    {
      key: "subTitle",
      title: "Subtitle",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{truncateString(value, 25) || "NA"}</span>;
      },
    },
    {
      key: "description",
      title: "Description",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{truncateString(value, 40) || "NA"}</span>;
      },
    },
    {
      key: "cmsType",
      title: "CMS Type",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{cmsTypeObj[value]}</span>;
      },
    },
  ],

  usersManagementactions: [
    {
      label: TCA.EDIT.LABEL,
      icon: TCA.EDIT.ICON,
      onClick: (item) => alert(`Edit ${item[UMK.NAME]}`),
    },
    {
      label: TCA.DELETE.LABEL,
      icon: TCA.DELETE.ICON,
      onClick: (item) => alert(`Delete ${item[UMK.NAME]}`),
    },
  ],
};

export const SUBSCRIPTION_TABLE_CONSTANT = {
  usersManagementcolumns: [
    // { key: "stripeInvoiceId", title: "Invoice Id", align: TCP.LEFT },
    {
      key: "plan.planName",
      title: "Plan Name",
      align: TCP.CENTER,
      render: (value, item) => {
        return <span>{item?.plan?.planName ?? "NA"}</span>;
      },
    },
    {
      key: "plan.isFreePlan",
      title: "Is Trial Included?",
      align: TCP.CENTER,
      render: (value, item) => {
        return <span>{item?.plan?.isFreePlan ? "Yes" : "No"}</span>;
      },
    },
    {
      key: "paymentStatusMessage",
      title: "payment Status",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "NA"}</span>;
      },
    },
    {
      key: "paymentType",
      title: "Payment Type",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "NA"}</span>;
      },
    },
    {
      key: "updatedAt",
      title: "Updated At",
      align: TCP.CENTER,
      render: (value) => {
        return (
          <span>
            {value ? moment(new Date(value)).format("DD MMMM YYYY") : "NA"}
          </span>
        );
      },
    },
  ],

  usersPaymentInvoiceColumns: [
    { key: "stripeInvoiceId", title: "Receipt Id", align: TCP.LEFT },
    {
      key: "subscriptionStartDate",
      title: "Subscription Start",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>{`${moment(value).format(
            "DD MMMM YYYY",
          )}`}</span>
        );
      },
    },
    {
      key: "subscriptionEndDate",
      title: "Subscription End",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>{`${moment(value).format(
            "DD MMMM YYYY",
          )}`}</span>
        );
      },
    },
    {
      key: "paymentStatusMessage",
      title: "payment Status",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "NA"}</span>;
      },
    },
    {
      key: "paymentType",
      title: "Payment Type",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "NA"}</span>;
      },
    },
  ],
  usersPaymentInvoiceColumnsInAdmin: [
    { key: "stripeInvoiceId", title: "Receipt Id", align: TCP.LEFT },
    {
      key: "subscriptionStartDate",
      title: "Subscription Start",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>{`${moment(value).format(
            "DD MMMM YYYY",
          )}`}</span>
        );
      },
    },
    {
      key: "subscriptionEndDate",
      title: "Subscription End",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>{`${moment(value).format(
            "DD MMMM YYYY",
          )}`}</span>
        );
      },
    },
    {
      key: "paymentStatusMessage",
      title: "payment Status",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "NA"}</span>;
      },
    },
    {
      key: "plan",
      title: "PlanName",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value?.planName || "NA"}</span>;
      },
    },
    {
      key: "paymentType",
      title: "Payment Type",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value || "NA"}</span>;
      },
    },
    {
      key: "amountReceived",
      title: "Amount",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value}</span>;
      },
    },
  ],
  AffiliatePaymentInvoiceColumnsInAdmin: [
    { key: "stripeInvoiceId", title: "Receipt Id", align: TCP.LEFT },
    {
      key: "transferDate",
      title: "Amount Recived Date",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>{`${moment(value).format(
            "DD MMMM YYYY",
          )}`}</span>
        );
      },
    },
    {
      key: "isTransfer",
      title: "Is Transfered",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value ? "YES" : "NO"}</span>;
      },
    },

    {
      key: "amountReceived",
      title: "Amount",
      align: TCP.CENTER,
      render: (value) => {
        return <span>{value}</span>;
      },
    },
  ],
  usersManagementactions: [
    {
      label: TCA.DOWNLOAD.LABEL,
      icon: TCA.DOWNLOAD.ICON,
      onClick: (item) => alert(`Download ${item[UMK.NAME]}`),
    },
  ],
};

export const CONTACT_US_TABLE_CONSTANT = {
  usersManagementcolumns: [
    {
      key: "name",
      title: "Name",
      align: TCP.LEFT,
    },
    {
      key: "email",
      title: "Email",
      align: TCP.LEFT,
    },
    {
      key: "phone",
      title: "Phone",
      align: TCP.LEFT,
    },
    {
      key: "message",
      title: "Message",
      align: TCP.CENTER,
      render: (value, item) => {
        return <span>{value ?? "NA"}</span>;
      },
    },
    {
      key: "slot",
      title: "Booked Slot",
      align: TCP.CENTER,
      render: (value, item) => {
        return (
          <span style={{ textTransform: "uppercase" }}>{`${moment(value).format(
            "DD MMMM YYYY hh:mm A",
          )}`}</span>
        );
      },
    },
    // {
    //   key: 'fileLink',
    //   title: 'View File',
    //   align: TCP.CENTER,
    //   render: (value, item) => {
    //     return <span style={{ textTransform: "uppercase" }}>{value ? window.location.href = value : ''}</span>
    //   }
    // },
  ],
};

export const formatDateTime = (selectedDate, selectedTime) => {
  const combinedDateTime = `${moment(selectedDate).format(
    "YYYY-MM-DD",
  )} ${selectedTime}`;
  const formattedDateTime = moment(
    combinedDateTime,
    "YYYY-MM-DD hh:mm A",
  ).format("YYYY-MM-DD HH:mm:ss");
  return formattedDateTime;
};

export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) {
    return "Just now";
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 172800) {
    return "Yesterday";
  } else if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} day${days > 1 ? "s" : ""} ago`;
  } else if (diffInSeconds < 31536000) {
    const weeks = Math.floor(diffInSeconds / 604800);
    return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
  } else {
    const years = Math.floor(diffInSeconds / 31536000);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  }
}

export function roundPercentageString(input = "") {
  // Remove the % sign, parse to float, round to 2 decimals, and reattach the %
  if (input.endsWith("%")) {
    let numericValue = parseFloat(input.replace("%", ""));
    return numericValue.toFixed(2) + "%";
  } else {
    return input;
  }
}

export const scopes = [
  { label: "businesses.readonly", value: "businesses.readonly" },
  { label: "businesses.write", value: "businesses.write" },
  { label: "calendars.write", value: "calendars.write" },
  { label: "calendars.readonly", value: "calendars.readonly" },
  { label: "calendars/groups.readonly", value: "calendars/groups.readonly" },
  { label: "calendars/groups.write", value: "calendars/groups.write" },
  {
    label: "calendars/resources.readonly",
    value: "calendars/resources.readonly",
  },
  { label: "calendars/resources.write", value: "calendars/resources.write" },
  { label: "calendars/events.readonly", value: "calendars/events.readonly" },
  { label: "calendars/events.write", value: "calendars/events.write" },
  { label: "campaigns.readonly", value: "campaigns.readonly" },
  { label: "contacts.readonly", value: "contacts.readonly" },
  { label: "contacts.write", value: "contacts.write" },
  { label: "objects/schema.readonly", value: "objects/schema.readonly" },
  { label: "objects/schema.write", value: "objects/schema.write" },
  { label: "objects/record.readonly", value: "objects/record.readonly" },
  { label: "objects/record.write", value: "objects/record.write" },
  { label: "conversations.readonly", value: "conversations.readonly" },
  { label: "conversations.write", value: "conversations.write" },
  {
    label: "conversations/message.readonly",
    value: "conversations/message.readonly",
  },
  {
    label: "conversations/message.write",
    value: "conversations/message.write",
  },
  {
    label: "conversations/livechat.write",
    value: "conversations/livechat.write",
  },
  { label: "forms.readonly", value: "forms.readonly" },
  { label: "invoices.readonly", value: "invoices.readonly" },
  { label: "invoices.write", value: "invoices.write" },
  { label: "invoices/schedule.readonly", value: "invoices/schedule.readonly" },
  { label: "invoices/schedule.write", value: "invoices/schedule.write" },
  { label: "invoices/template.readonly", value: "invoices/template.readonly" },
  { label: "invoices/template.write", value: "invoices/template.write" },
  { label: "links.readonly", value: "links.readonly" },
  { label: "links.write", value: "links.write" },
  { label: "locations.readonly", value: "locations.readonly" },
  { label: "LocationUpdate", value: "LocationUpdate" },
  { label: "locations.write", value: "locations.write" },
  {
    label: "locations/customValues.readonly",
    value: "locations/customValues.readonly",
  },
  {
    label: "locations/customValues.write",
    value: "locations/customValues.write",
  },
  {
    label: "locations/customFields.readonly",
    value: "locations/customFields.readonly",
  },
  {
    label: "locations/customFields.write",
    value: "locations/customFields.write",
  },
  { label: "locations/tags.readonly", value: "locations/tags.readonly" },
  { label: "locations/tags.write", value: "locations/tags.write" },
  {
    label: "locations/templates.readonly",
    value: "locations/templates.readonly",
  },
  { label: "locations/tasks.readonly", value: "locations/tasks.readonly" },
  { label: "medias.readonly", value: "medias.readonly" },
  { label: "medias.write", value: "medias.write" },
  { label: "funnels/redirect.readonly", value: "funnels/redirect.readonly" },
  { label: "funnels/redirect.write", value: "funnels/redirect.write" },
  { label: "funnels/page.readonly", value: "funnels/page.readonly" },
  { label: "funnels/funnel.readonly", value: "funnels/funnel.readonly" },
  { label: "funnels/pagecount.readonly", value: "funnels/pagecount.readonly" },
  { label: "opportunities.readonly", value: "opportunities.readonly" },
  { label: "opportunities.write", value: "opportunities.write" },
  {
    label: "payments/integration.readonly",
    value: "payments/integration.readonly",
  },
  { label: "payments/integration.write", value: "payments/integration.write" },
  { label: "payments/orders.readonly", value: "payments/orders.readonly" },
  { label: "payments/orders.write", value: "payments/orders.write" },
];

export function formatNumberCount(number = 0) {
  if (number < 1000) {
    return `${number}`; // Numbers less than 1000 remain unchanged
  } else if (number < 1_000_000) {
    return `${(number / 1000).toFixed(1)}K`; // Format in 'K' for thousands
  } else if (number < 1_000_000_000) {
    return `${(number / 1_000_000).toFixed(1)}M`; // Format in 'M' for millions
  } else {
    return `${(number / 1_000_000_000).toFixed(1)}B`; // Format in 'B' for billions
  }
}

export const menuPermission = [
  { dashboard: { user: [1, 2, 3, 4, 5], permission: [0, 0, 1, 0] } },
  { "my-chatbot": { user: [1, 2, 3, 4, null], permission: [1, 1, 1, 1] } },
  {
    "chatbot-registered-contacts": {
      user: [1, 2, 3, 4, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "chatbot-visitor-contacts": {
      user: [1, 2, 3, 4, null],
      permission: [1, 1, 1, 1],
    },
  },

  {
    "chatbot-metadata": { user: [1, 2, 3, 4, null], permission: [1, 1, 1, 1] },
  },
  {
    "chatbot-analytics": { user: [1, 2, 3, 4, null], permission: [0, 0, 1, 0] },
  },
  { "chat-history": { user: [1, 2, 3, 4, null], permission: [0, 0, 1, 0] } },
  { "my-subscription": { user: [1, 2, 3, 4, null], permission: [1, 1, 1, 1] } },
  {
    "branding-management": {
      user: [null, null, 3, null, null],
      permission: [1, 1, 1, 0],
    },
  },
  {
    "my-payment-account-details": {
      user: [null, null, 3, null, 5],
      permission: [1, 1, 1, 0],
    },
  },
  {
    "my-refer-link": {
      user: [null, null, null, null, 5],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "my-earnings": {
      user: [null, null, null, null, 5],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "referral-activity": {
      user: [null, null, null, null, 5],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "client-management": {
      user: [null, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "client-subscription-details": {
      user: [null, null, 3, null, null],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "customer-management": {
      user: [1, null, null, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "revenue-report": {
      user: [1, null, 3, null, null],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "promo-code-management": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "plan-managemnet": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  }, //need to discuss
  {
    "contact-us-details": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "informative-content": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "site-content": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "social-links": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "agency-management": {
      user: [1, null, null, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "agency-user-activity": {
      user: [1, null, null, null, null],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "affiliate-user-list": {
      user: [1, null, null, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "affiliate-earnings": {
      user: [1, null, null, null, null],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "customer-subscripstion-mangement": {
      user: [1, null, null, null, null],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "agency-subscription-mangement": {
      user: [1, null, null, null, null],
      permission: [0, 0, 1, 0],
    },
  },
  {
    "designation-management": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  {
    "employee-mangement": {
      user: [1, null, 3, null, null],
      permission: [1, 1, 1, 1],
    },
  },
  { "human-takeover": { user: [1, 2, 3, 4, null], permission: [1, 1, 1, 1] } },
  {
    "pricing-query": {
      user: [1, null, null, null, null],
      permission: [1, 1, 1, 1],
    },
  },
];

export const menuDynamicRoute = {
  //[1, 2/4, 3, 5] Access Type
  dashboard: {
    route: [
      "/admin/dashboard",
      "/dashboard",
      "/agency/dashboard",
      "/affiliate/dashboard",
    ],
    label: "Dashboard",
    icon: "/images/icons/menu-dashboard",
  },
  "my-chatbot": {
    route: ["/admin/my-chatbots", "/my-chatbots", "/agency/my-chatbots", null],
    label: "My Chatbots",
    icon: "/images/icons/menu-my-chatbots",
  },
  "chatbot-registered-contacts": {
    route: [
      "/admin/chatbot-registered-contacts",
      "/chatbot-registered-contacts",
      "/agency/chatbot-registered-contacts",
      null,
    ],
    label: "Registered Contacts",
    icon: "/images/icons/menu-chatbot-contact",
  },
  "chatbot-visitor-contacts": {
    route: [
      "/admin/chatbot-visitor-contacts",
      "/chatbot-visitor-contacts",
      "/agency/chatbot-visitor-contacts",
      null,
    ],
    label: "Chatbot Contacts",
    icon: "/images/icons/menu-chatbot-contact",
  },
  "chatbot-metadata": {
    route: [
      "/admin/chatbot-metadata",
      "/chatbot-metadata",
      "/agency/chatbot-metadata",
      null,
    ],
    label: "Chatbot Metadata",
    icon: "/images/icons/menu-chatbot-metadata",
  },
  "chatbot-analytics": {
    route: ["/admin/analytics", "/analytics", "/agency/analytics", null],
    label: "Chatbot Analytics",
    icon: "/images/icons/menu-chatbots-analytics",
  },

  "chat-history": {
    route: [
      "/admin/chat-history",
      "/chat-history",
      "/agency/chat-history",
      null,
    ],
    label: "Chat History",
    icon: "/images/icons/menu-chat-history",
  },
  "my-subscription": {
    route: [null, "/my-plan", "/agency/my-plan"],
    label: "My Subscription",
    icon: "/images/icons/menu-my-subscription",
  },
  "branding-management": {
    route: [null, null, "/agency/branding-management", null],
    label: "Branding Management",
    icon: "/images/icons/menu-informative-content-management",
  },
  "my-payment-account-details": {
    route: [
      null,
      null,
      "/agency/payment-management",
      "/affiliate/payment-management",
    ],
    label: "My Payment Account Details",
    icon: "/images/icons/menu-reveneu-report",
  },
  "my-refer-link": {
    route: [null, null, null, "/affiliate/referral-link"],
    label: "My Referral Link",
    icon: "/images/icons/menu-reveneu-report",
  },
  "client-subscription-details": {
    route: [null, null, "/agency/subscription-management", null],
    label: "Client Subscription Setails",
    icon: "/images/icons/menu-customer-subscription-details",
  },
  "revenue-report": {
    route: ["/admin/revenue-report", null, "/agency/revenue-report", null],
    label: "Revenue Report",
    icon: "/images/icons/menu-reveneu-report",
  },
  // "promo-code-management": {
  //   route: ["/admin/promocode", null, "/agency/promocode", null],
  //   label: "Promo Code Management",
  //   icon: "/images/icons/menu-promocode",
  // },
  "plan-management": {
    route: ["/admin/plan", null, "/agency/plan", null],
    label: "Plan Managemnet",
    icon: "/images/icons/menu-plan-management",
  },

  "referral-activity": {
    route: [null, null, null, "/affiliate/referral-activity"],
    label: "Referral Activity",
    icon: "/images/icons/menu-customer-subscription-details",
  },
  "my-earnings": {
    route: [null, null, null, "/affiliate/earning"],
    label: "My Earnings",
    icon: "/images/icons/menu-customer-subscription-details",
  },
  // 'my-payment-account-details': {route:[null, null, null, '/affiliate/my-earnings'], label:'Contact Us Details', icon1:'/images/icons/menu-customer-subscription-details'},

  "informative-content": {
    route: ["/admin/cms", null, "/agency/cms", null],
    label: "Content Management",
    icon: "/images/icons/menu-agency-management",
  },

  "contact-us-details": {
    route: [
      "/admin/contact-us-management",
      null,
      "/agency/contact-us-management",
      null,
    ],
    label: "Contact us Management",
    icon: "/images/icons/menu-agency-management",
  },

  // 'informative-content': {parent:"Content Management", route:['/admin/cms', null, '/agency/cms', null], label:'Informative Content', icon:'/images/icons/menu-agency-management', parentLabel:"Content Management", parentIcon:'/images/icons/menu-agency-management'},
  // 'site-content': {parent:"Content Management",route:['/admin/site-content-management', null, '/agency/site-content-management', null], label:'Site Content', icon:'/images/icons/menu-agency-management', parentLabel:"Content Management", parentIcon:'/images/icons/menu-agency-management'},
  // 'social-links': {parent:"Content Management", route:['/admin/link-management', null, '/agency/link-management', null], label:'Social Links', icon:'/images/icons/menu-agency-management', parentLabel:"Content Management", parentIcon:'/images/icons/menu-agency-management'},

  "client-management": {
    route: [null, null, "/agency/child-client", null],
    label: "Client Management",
    icon: "/images/icons/menu-customer-management",
  },
  "customer-management": {
    route: ["/admin/customer", null, null, null],
    label: "Customer Management",
    icon: "/images/icons/menu-customer-management",
  },

  "agency-management": {
    parent: "Agency Management",
    route: ["/admin/agency-management", null, null, null],
    label: "Parent Agency",
    icon: "/images/icons/menu-agency-management",
    parentLabel: "Agency Management",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "agency-user-activity": {
    parent: "Agency Management",
    route: ["/admin/agency-management/view", null, null, null],
    label: "Agency User Activity",
    icon: "/images/icons/menu-agency-management",
    parentLabel: "Agency Management",
    parentIcon: "/images/icons/menu-agency-management",
  },

  "affiliate-user-list": {
    parent: "Affiliate Management",
    route: ["/admin/affiliate-management", null, null, null],
    label: "Affiliate User List",
    icon: "/images/icons/menu-affiliate-management",
    parentLabel: "Affiliate Management",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "affiliate-earnings": {
    parent: "Affiliate Management",
    route: ["/admin/affiliate-management/view", null, null, null],
    label: "Affiliate Earnings",
    icon: "/images/icons/menu-affiliate-management",
    parentLabel: "Affiliate Management",
    parentIcon: "/images/icons/menu-agency-management",
  },

  "customer-subscription-management": {
    parent: "Subscription Details",
    route: ["/admin/subscription-management/subscriber", null, null, null],
    label: "Customer Subscripstion",
    icon: "/images/icons/menu-customer-subscription-details",
    parentLabel: "Subscription Details",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "agency-subscription-management": {
    parent: "Subscription Details",
    route: ["/admin/subscription-management/parent_agency", null, null, null],
    label: "Agency Subscription",
    icon: "/images/icons/menu-customer-subscription-details",
    parentLabel: "Subscription Details",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "client-subscription-details": {
    parent: "Subscription Details",
    route: [null, null, "/agency/subscription-management", null],
    label: "Child Subscripstion",
    icon: "/images/icons/menu-customer-subscription-details",
    parentLabel: "Subscription Details",
    parentIcon: "/images/icons/menu-agency-management",
  },

  "client-management": {
    route: [null, null, "/agency/child-client", null],
    label: "Client Management",
    icon: "/images/icons/menu-customer-management",
  },
  "customer-management": {
    route: ["/admin/customer", null, null, null],
    label: "Customer Management",
    icon: "/images/icons/menu-customer-management",
  },

  "agency-management": {
    parent: "Agency Management",
    route: ["/admin/agency-management", null, null, null],
    label: "Parent Agency",
    icon: "/images/icons/menu-agency-management",
    parentLabel: "Agency Management",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "agency-user-activity": {
    parent: "Agency Management",
    route: ["/admin/agency-management/view", null, null, null],
    label: "Agency User Activity",
    icon: "/images/icons/menu-agency-management",
    parentLabel: "Agency Management",
    parentIcon: "/images/icons/menu-agency-management",
  },

  "affiliate-user-list": {
    parent: "Affiliate Management",
    route: ["/admin/affiliate-management", null, null, null],
    label: "Affiliate User List",
    icon: "/images/icons/menu-affiliate-management",
    parentLabel: "Affiliate Management",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "affiliate-earnings": {
    parent: "Affiliate Management",
    route: ["/admin/affiliate-management/view", null, null, null],
    label: "Affiliate Earnings",
    icon: "/images/icons/menu-affiliate-management",
    parentLabel: "Affiliate Management",
    parentIcon: "/images/icons/menu-agency-management",
  },

  "customer-subscription-management": {
    route: ["/admin/subscription-management/subscriber", null, null, null],
    label: "Customer Subscription",
    icon: "/images/icons/menu-customer-subscription",
  },
  // 'customer-subscription-management': { parent: "Subscription Details", route: ['/admin/subscription-management/subscriber', null, null, null], label: 'Customer Subscripstion', icon: '/images/icons/menu-customer-subscription-details', parentLabel: "Subscription Details", parentIcon: '/images/icons/menu-agency-management' },
  // 'agency-subscription-management': { parent: "Subscription Details", route: ['/admin/subscription-management/parent_agency', null, null, null], label: 'Agency Subscription', icon: '/images/icons/menu-customer-subscription-details', parentLabel: "Subscription Details", parentIcon: '/images/icons/menu-agency-management' },
  // 'client-subscription-details': { parent: "Subscription Details", route: [null, null, '/agency/subscription-management', null], label: 'Child Subscripstion', icon: '/images/icons/menu-customer-subscription-details', parentLabel: "Subscription Details", parentIcon: '/images/icons/menu-agency-management' },

  "designation-management": {
    parent: "Access Management",
    route: [
      "/admin/role-management",
      "/role-management",
      "/agency/role-management",
      null,
    ],
    label: "Designation Management",
    icon: "/images/icons/menu-customer-subscription-details",
    parentLabel: "Access Management",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "employee-management": {
    parent: "Access Management",
    route: [
      "/admin/employee-management",
      "/employee-management",
      "/agency/employee-management",
      null,
    ],
    label: "Employee Mangement",
    icon: "/images/icons/menu-customer-subscription-details",
    parentLabel: "Access Management",
    parentIcon: "/images/icons/menu-agency-management",
  },
  "human-takeover": {
    route: [
      "/admin/human-takeover?tab=1",
      "/human-takeover?tab=1",
      "/agency/human-takeover?tab=1",
      null,
    ],
    label: "Human Takeover",
    icon: "/images/icons/menu-human-takeover",
  },
  marketing: {
    route: ["/admin/marketing", "/marketing", null, null],
    label: "Marketing",
    icon: "/images/icons/menu-informative-content-management",
  },
  "pricing-query": {
    route: ["/admin/pricing-query", "/pricing-query", null, null],
    label: "Marketing",
    icon: "/images/icons/menu-informative-content-management",
  },
  "exchange-rate-setting": {
    route: ["/admin/exchange-rate-setting", null, null, null],
    label: "Exchange Rate Setting",
    icon: "/images/icons/menu-informative-content-management",
  },
}; //for route arr the order of routes must be as per userType order {1: "super_admin", 2: "subscriber", 3: "parent_agency", 4: "affiliate"} by Sharmishtha Das

export const menuStaticRoute = [
  // { 'chatbot-model-settings': { route: ['/admin/chatbot-model-settings'], label: 'AI Model Settings', icon: '/images/icons/menu-ai-model-settings' } },
  {
    settings: {
      route: [
        "/admin/settings",
        "/settings",
        "/agency/settings",
        "/affiliate/settings",
      ],
      label: "Settings",
      icon: "/images/icons/menu-setting",
    },
  },
  {
    feedback: {
      route: [null, "/feedback", "/agency/feedback", "/affiliate/feedback"],
      label: "Feedback",
      icon: "/images/icons/menu-feedback",
    },
  },
  {
    help: {
      route: [null, "/help", "/agency/help", "/affiliate/help"],
      label: "Help",
      icon: "/images/icons/menu-help",
    },
  },
  {
    profile: {
      route: [
        "/admin/profile",
        "/profile",
        "/agency/profile",
        "/affiliate/profile",
      ],
      label: "Profile",
      icon: "",
    },
  },
  {
    notifications: {
      route: [
        "/admin/notifications",
        "/notifications",
        "/agency/notifications",
        "/affiliate/notifications",
      ],
      label: "Profile",
      icon: "",
    },
  },
  {
    "exchange-rate-setting": {
      route: ["/admin/exchange-rate-setting"],
      label: "Exchange Rate Settings",
      icon: "",
    },
  },
  {
    "pricing-query": {
      route: ["/admin/pricing-query"],
      label: "Pricing Query",
      icon: "",
    },
  },
  {
    "sample-prompt-and-qna": {
      route: ["/admin/sample-prompt-and-qna"],
      label: "Sample Prompt And Qna",
      icon: "",
    },
  },
]; //These are the menu for which we will not put any restriction method to go to that menu by Sharmishtha Das

export const hiddenPath = [
  "payment-status",
  "my-plan",
  "plan-list",
  "settings",
  "payment-success",
  "payment-failure",
  "feedback",
  "help",
  "help/onboarding-tutorials",
  "payment-management",
  "access-management",
  "ghl/connect",
  "documentation/onboarding-tutorials",
]; //These are the routes for with there will be no restriction to access by Sharmishtha Das

export const guestRoute = [
  "bot-test",
  "migration-consent",
  "pricing",
  "documentation",
  "contact-us",
  "features",
  "privacy-policy",
  "refund-policy",
  "affiliate",
  "terms-of-service",
  "bot-preview",
  "product-literature",
];

export const ksCalenderType = [
  { key: "self", label: "Self Booking" },
  { key: "auto", label: "Auto Scheduling (By Google)" },
];

export const ksCalenderPlatform = [
  { key: "google", label: "Google Calender" },
  { key: "ms", label: "Microsoft Calender" },
];

export const preDefinedPosParams = {
  winWidth: 1536,
  winHeight: 730,
  botDescBoxX: 1425,
  botDescBoxY: 650,
  resizableDivPosX: 1125,
  resizableDivPosY: 285,
  descBoxMinWidth: 360,
  descBoxMinHeight: 425,
  descBoxMaxWidth: 650,
  descBoxMaxHeight: 720,
  desc_box_x: 1425,
  desc_box_y: 650,
  chat_box_x: 1085,
  chat_box_y: 395,
  viewport_x: 1425,
  viewport_y: 650,
  primaryPosX: 1425,
  primaryPosY: 650,
  posTopLeftX: 20,
  posTopLeftY: 20,
  posTopRightX: 1425,
  posTopRightY: 20,
  posButtomLeftX: 20,
  posButtomLeftY: 650,
  posButtomRightX: 1425,
  posButtomRightY: 650,

  fromRightGapping: 111,
  fromButtomGapping: 80,
};
// export const routeMenuMapping = {
// "dashboard":"dashboard",
// "my-chatbots":"my-chatbot",
// "bot-settings":"bot-settings",
// "chat-history":"chat-history",
// "my-plan":"my-plan",
// "profile":"profile",
// "analytics":"/chatbot-analytics",
// "settings":"settings",
// // "payment-status":"",
// // "payment-success":"",
// // "payment-failure":"",
// // "plan-list":"",
// "help":"help",
// "role-management":"role",
// "role-management/create":"/dashboard",
// "role-management/edit":"/dashboard",
// "notifications":"/dashboard",
// "ghl/form":"/dashboard",
// "ghl/connect":"/dashboard",
// "feedback":"/dashboard",
// "customer":"/dashboard",
// "customer/create":"/dashboard",
// "customer/edit":"/dashboard",
// "subscription-management":"/dashboard",
// "promocode":"/dashboard",
// "promocode/create":"/dashboard",
// "plan":"/dashboard",
// "plan/create":"/dashboard",
// "plan/edit":"/dashboard",
// "cms":"/dashboard",
// "cms/create":"/dashboard",
// "cms/edit":"/dashboard",
// "contact-us-management":"/dashboard",
// "access-management":"/dashboard",
// "revenue-report":"/dashboard",
// "notifications":"/dashboard",
// "link-management":"/dashboard",
// "agency-management":"/dashboard",
// "agency-management/user-activity":"/dashboard",
// "affiliate-management":"/dashboard",
// "affiliate-management/commission":"/dashboard",
// "site-content-management":"/dashboard",
// "referal-activity":"/dashboard",
// "referral-link":"/dashboard",
// "earning":"/dashboard",
// "payment-management":"/dashboard",
// "child-client":"/dashboard",
// "child-client/create":"/dashboard",
// "child-client/edit":"/dashboard",
// "branding-management":"/dashboard",
// "dashboard":"/dashboard",
// } //we are concidering the end route path excluding the usertype part, to map with menu by Sharmishtha Das

//All module and menu items
// export const menuItems = {
//  "super_admin":[ { path: "/admin/dashboard", key: "dashboard", label: "Dashboard", icon: "menu-dashboard" },
//   { path: "/admin/my-chatbots", key: "myChatbots", label: "My Chatbots", icon: "menu-my-chatbots"  },
//   { path: "/admin/analytics", key: "chatbotAnalytics", label: "Chatbot Analytics", icon: "menu-chatbots-analytics"  },
//   { path: "/admin/chat-history", key: "chatHistory", label: "Chat History", icon: "menu-chat-history"  },
//   { path: "/admin/settings", key: "settings", label: "Settings", icon: "menu-setting"  },
//   { path: "/admin/role", key: "userManagement", label: "Customer Management", icon: "menu-setting"  },
//   { path: "/admin/subscription-management", key: "subscriptionManagement", label: "Customer Subscription Details", icon: "menu-setting" },
//   { path: "/admin/promocode", key: "promocodeManagement", label: "Promo Code Management", icon: "menu-setting" },
//   { path: "/admin/plan", key: "planManagement", label: "Plan Management", icon: "menu-setting" },
//   {
//     path: "/admin/cms",
//     key: "cmsManagement",
//     label: "Informative Content Management",
//     icon: "menu-setting",

//   }],
//   "user":[
//   { path: "/dashboard", key: "dashboard", label: "Dashboard", icon: "menu-dashboard" },
//   { path: "/my-chatbots", key: "myChatbots", label: "My Chatbots", icon: "menu-my-chatbots"  },
//   { path: "/analytics", key: "chatbotAnalytics", label: "Chatbot Analytics", icon: "menu-chatbots-analytics"  },
//   { path: "/chat-history", key: "chatHistory", label: "Chat History", icon: "menu-chat-history"  },
//   { path: "/my-plan", key: "myPlan", label: "My Subscription", icon: "menu-my-subscription"  },
//   { path: "/settings", key: "settings", label: "Settings", icon: "menu-setting"  },
//   ]
// };
export const ExportTXT = (txtString, fileName) => {
  try {
    const blob = new Blob([txtString], { type: "text/plain;charset=utf-8;" });
    const link = document.createElement("a");

    if (link.download !== undefined) {
      const formattedDate = moment().format("DD_MMM_YYYY");
      let fileName_local = `${fileName}_${formattedDate}`;

      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName_local);
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error exporting TXT:", error);
  }
};

export const disclaimerText = `The Chatbot always includes masking,
            encryption, and sensitive data using pattern recognition/detection,
            even for non-compliant sites like landscaping or hairstyling. I
            agree NOT to knowingly process or intentionally discuss Protected
            Health Information (PHI) or sensitive US personal data under HIPAA
            (e.g., names, SSNs, medical records, etc.) or sensitive EU personal
            data under GDPR (e.g., names, health info, etc.). I understand that
            if I do so without enabling compliance and signing the business
            associate agreement (BAA) and/or the data processing agreement
            (DPA), I am solely liable for any violations, fines, or legal
            actions—despite full functionality. I further agree that this
            chatbot may not be repurposed for HIPAA or GDPR compliance purposes;
            a new chatbot must be created and properly configured for such use.`;

export const currency_rate = [
  {
    country: "Uk",
    currency_name: "gbp",
    rate: "0.74",
  },
  {
    country: "Australia",
    currency_name: "aud",
    rate: "1.53",
  },
  {
    country: "Japan",
    currency_name: "jpy",
    rate: "147.07",
  },
];
